module.exports = __webpack_public_path__ + "img/close.5d0bcd8d.svg";